import './_dialog';
import PerfectScrollbar from 'perfect-scrollbar';
import "perfect-scrollbar/css/perfect-scrollbar.css";

$(function() {
    (new PerfectScrollbar('.perfect-scrollbar')).update();

    let tab = $('.seminar__list').data('tab');

    if (!tab) {
        tab = 'all';
    }

    $('.seminar__list li').each(function () {
        $(this).find('a').attr('href', $(this).data('link') + '?tab=' + tab);
    });

    $('input[name="filter-type"]').on('click', function () {
        let clickTab = $(this).data('tab');

        $('.seminar__list li').each(function () {
            $(this).find('a').attr('href', $(this).data('link') + '?tab=' + clickTab);
        });
    });

    $('#signUpForm').find('input[type="submit"]')
        .on('click', function () {
            $(this).prop('disabled', true);

            $('#signUpForm').submit();
        });

    $('body').on('click', '.article__content #article-content a', function (e) {
        e.preventDefault();

        var href = $(this).attr('href');

        if (!! /#\w+/.test(href)) {
            $('html, body').animate({
                scrollTop: ($(href).offset().top - 100)
            }, 700);

            return;
        }

        switch ($(this).attr('target')) {
            case '_blank':
                window.open(href, '_blank');
                break;
            case '_self':
                window.open(href, '_self');
                break;
            case '_top':
                window.open(href, '_top');
                break;
            case '_parent':
                window.open(href, '_parent');
                break;
            default:
                window.open(href, '_self');
        }
    });
});
